import { Avatar, Box, Button, Typography } from "@mui/material";
import { pluralize } from "~/lib/pluralize";
import { UserProfile } from "../types";

export type UserHeaderProps = {
  user: UserProfile;
  onRemoveUser: () => void;
  canRemove: boolean;
};

export function UserHeader({ user, onRemoveUser, canRemove }: UserHeaderProps) {
  const initials = user.name
    ? user.name
        .split(" ")
        .map((n: string) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2)
    : "?";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 4,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Avatar
          sx={{
            width: 80,
            height: 80,
            fontSize: "28px",
            bgcolor: "primary.main",
          }}
        >
          {initials}
        </Avatar>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 600 }}>
            {user.name}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {user.name} has access to {user.spaceCount}{" "}
            {pluralize("space", user.spaceCount)}
          </Typography>
        </Box>
      </Box>

      {canRemove && (
        <Button
          variant="outlined"
          color="error"
          onClick={onRemoveUser}
          sx={{ textTransform: "uppercase" }}
        >
          Remove User
        </Button>
      )}
    </Box>
  );
}
